import * as moment from 'moment';
import { User } from './user';

export class MarineGroup {
  name = '';
  planUuids: string[] = [];
  uuid: string;
  description: string;
  privateGroup = true;
  members: User[] = [];
  owners: User[] = [];
  requestedMembers: User[] = [];
  author: string;
  createdAt: moment.Moment;

  /**
   * Set the name of the group. Return this for chaining purposes.
   *
   * @param  {string} name - name to save
   * @returns MarineGroup
   */
  setName(name: string): MarineGroup {
    this.name = name;
    return this;
  }

  /**
   * Set the uuid of the group. Return this for chaining purposes.
   *
   * @param  {string} id - uuid of group to save
   * @returns MarineGroup
   */
  setUuid(id: string): MarineGroup {
    this.uuid = id;
    return this;
  }

  /**
   * Add a copy of each users to the list of members of the group. I think the copy part is OBE.
   *
   * @param  {User[]} users - list of users to add
   * @returns MarineGroup
   */
  addUsers(users: User[]): MarineGroup {
    this.members = this.members.concat(users.map(user => {
      const newMember = {...user} as User;
      return newMember;
    }));
    return this;
  }

  /**
   * Replace the entire list of users with a new list of copied users.
   *
   * @param  {User[]} users - users to be replaced with
   * @returns MarineGroup
   */
  replaceUsers(users: User[]): MarineGroup {
    this.members = users.map(user => {
      const newMember = { ...user } as User;
      return newMember;
    });
    return this;
  }

  /**
   * Add a list of owners to the group as a copy.
   *
   * @param  {User[]} users - list of owners to add
   * @returns MarineGroup
   */
  addOwners(users: User[]): MarineGroup {
    this.owners = this.owners.concat(users.map(user => {
      const newMember = {...user} as User;
      newMember.owner = true;
      newMember.invited = false;
      return newMember;
    }));
    return this;
  }

  /**
   * Add the list of users that are requesting to join the group.
   *
   * @param  {User[]} users - list of users to add
   * @returns MarineGroup
   */
  addRequestedUsers(users: User[]): MarineGroup {
    this.requestedMembers = this.requestedMembers.concat(users.map(user => {
      const newMember = {...user} as User;
      return newMember;
    }));
    return this;
  }

  /**
   * Return a list of first names of the owners of the group.
   *
   * @returns string
   */
  get ownersList(): string {
    return this.owners.map((ownerUser: User) => {
      return ownerUser.firstName;
    }).join(', ');
  }
}
